export function sortByKey(array: any[], key: string) {
  array.sort((a, b) => (a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0));
}

/**
 * Returns the Tailwind CSS className string for ReactTooltip components
 * @param isDarkMode - Whether dark mode is enabled
 * @returns A className string with tooltip styling
 */
export function getTooltipClassName(isDarkMode: boolean): string {
  return `text-white rounded-xl! px-3! py-2! text-sm ${isDarkMode ? "bg-gray-700" : "bg-gray-800"} z-9999!`;
}
